import { useState } from "react";

import styled from "styled-components";

import { BlankImage } from "./BlankImage";

enum Status {
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
}

type Props = { imageUrl: string; show: boolean };

export const Image = ({ imageUrl, show }: Props) => {
  const [status, setStatus] = useState<Status>(Status.LOADING);

  return (
    <Container className={show ? "show" : ""}>
      {status === Status.SUCCESS || status === Status.LOADING ? (
        <StyledImage
          src={imageUrl}
          onError={() => setStatus(Status.ERROR)}
          onLoad={() => setStatus(Status.SUCCESS)}
          loading="lazy"
        />
      ) : (
        <BlankImage />
      )}
    </Container>
  );
};

const Container = styled.div`
  transition: opacity 0.5s;
  opacity: 0;
  &.show {
    opacity: 1;
  }
`;

const StyledImage = styled.img`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.5s;
`;
